import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { decode, encode } from "base-64";
const cookies = new Cookies();
var token = cookies.get("wmtoken");

// var token = encode(JSON.stringify({"id":"132","token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2Mzk1NTQyNTUsImNoayI6MTEyNDQzNzg4MiwidXNlcm5hbWUiOiJyb25ha2FnYWxhQGdtYWlsLmNvbSIsImlkIjoiMTMyNyIsImlzcyI6Ildpc2Vtb25rZXlzLndlYiIsImV4cCI6MTYzOTU1NDMxNX0.cXbryjgqNNx1MiWXkYYX5hNwkLHxmop2hfWKIkUygvg"}))

export const getWhoIsLoggedIn = async () => {
  var fd = new FormData();
  if (token) {
    { token && fd.append("token", decode(token)) }
    fd.append("identity", "wmhandler");
    var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Authentication/fetchUserData`, data: fd })
    return await res.data[0]
  }
};

export const getNotifications = async () => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/fetchNotificationData`, data: fd })
    return await res.data;
  }
}

export const updateNotification = async (ids) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("notification_id", JSON.stringify(ids));
    var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/updateViewOfNotification`, data: fd })
    return await res.data
  }
}
export const getPostCount = async () => {
  const res = await axios(`${API_ENDPOINT.apiURL}Profile/getTotalPosts`)
  return await res.data
}


export const getCategory = async () => {
  const res = await axios(`${API_ENDPOINT.apiURL}Profile/getCategoryList`)
  return await res.data
}

export const getUsersEntireData = async () => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("screen_name", "PROFILE");
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/getUserProfileData`, data: fd })
    return await res.data
  }
}

export const getFollowFollowingList = async (action) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("viewType", action);
    // fd.append("profileId", 27);
    fd.append("pageNo", 0);
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/getFollowFollowing`, data: fd })
    return await res.data
  }
};

export const uploadPhoto = async (pic) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("photoType", "profile");
    fd.append("profile", pic);
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/updateUserPhoto`, data: fd })
    return await res.data
  }
};

export const resumeBuild = async (resumeData) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("action", "SAVE");
    fd.append("resume_data", JSON.stringify(resumeData));
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/resumeData`, data: fd })
    return await res.data
  }
};
export const getResumeData = async () => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("action", "GET");
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/resumeData`, data: fd })
    return await res.data
  }
};
export const deleteResume = async () => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("action", "DELETE");
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/resumeData`, data: fd })
    return await res.data
  }
};
export const updateInstituteBio = async (bio) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("bio", bio);
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/updateInstituteLandingPage`, data: fd })
    return await res.data
  }
};

export const getNotice = async (username, action) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("institute_name", username);
    fd.append("action", action);
    const res = await axios({ method: "post", url: `${API_ENDPOINT.apiURL}profile/getNoticeData`, data: fd })
    return await res.data
  }
};
// export const updateNotice = async(notice) => {
//   var fd = new FormData();
//   if (token) {
//     fd.append("token", decode(token));
//     fd.append("identity", "wmhandler");
//     fd.append("content", notice);
//     const res = await axios({method: "POST",url: `${API_ENDPOINT.apiURL}profile/createNotice`,data: fd,})
//     return await res.data
//   }
// };
export const hideCertForPublic = async (certId, action, label, description) => {
  console.log(certId, action, label, description)
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("cert_id", certId);
    fd.append("action", action ? '1' : '0');
    fd.append("user_label", label);
    fd.append("description", description);
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/updateCertPublicView`, data: fd, })
    return await res.data
  }
};
export const createNotice = async (content, link, end_date) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("content", content);
    fd.append("link", link);
    // end_date
    fd.append("end_date", Math.floor(new Date(end_date).getTime() / 1000));
    fd.append("action", "CREATE");
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/noticeManagement`, data: fd, })
    return await res.data
  }
};
export const updateNotice = async (noticeID, content, link, end_date) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("content", content);
    fd.append("link", link);
    fd.append("end_date", end_date);
    fd.append("action", "UPDATE");
    fd.append("noticeId", noticeID);
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/noticeManagement`, data: fd, })
    return await res.data
  }
};
export const deleteNotice = async (noticeID) => {
  var fd = new FormData();
  if (token) {
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("noticeId", noticeID);
    fd.append("action", 'DELETE');
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/noticeManagement`, data: fd, })
    return await res.data
  }
};


